export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14995.90eef62f.jpg";